import React, { useState, useEffect } from "react";
import Section from "../../components/base/Section.jsx";
import PriceItemAdminV2 from "../../components/priceItemAdminV2.jsx";
import AddPrice from "../../components/addPrice.jsx";
import Button from "../../components/base/Button.jsx";
import Input from "../../components/base/Input.jsx";
import { theme } from "../../theme.js";
import { PlusIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { icon } from "leaflet";

export default function CreateRacePrices({prices, setPrices, corrals, setCorrals}) {
    
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 768);
    const [newChoice, setNewChoice] = useState("");

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

    const handleAddPrice = (price) => {
        setPrices([...prices, price]);
    }

    const handleAddChoice = () => {
        if (newChoice.trim()) {
        setCorrals([...corrals, newChoice.trim()]);
        setNewChoice("");
    }
  };

  const handleRemoveChoice = (index) => {
    setCorrals(corrals.filter((_, i) => i !== index));
  };

    return (
    <div style={styles.step1}>
    <div style={{ ...styles.mainColumn, marginLeft: isMobile ? theme.spacing.sm : theme.spacing.huge, marginRight: isMobile ? theme.spacing.sm : theme.spacing.huge }}>
            <Section title="Gérez les tarifs">
              <p style={styles.description}>
                Créez les différents tarifs pour cette course
              </p>
            <div style={{marginBottom: '20px', width: "100%", display: "flex", flexWrap: "wrap", gap: "12px"}}>
              {prices && prices.map((price) => (
                  <PriceItemAdminV2 key={price.id_bdd} price={price} prices={prices} setPrices={setPrices} />
              ))}
            </div>
            <Button
                title="Ajouter un prix"
                icon={PlusIcon}
                onClick={() =>
                    handleAddPrice({
                    id_bdd: Date.now(),
                    type: "other",
                    })
                }
            />
            </Section>
            <Section title="Gérez les SAS">
              <p style={styles.description}>
                Ajoutez des sas de départ pour organiser vos coureurs
              </p>
            <div style={styles.formGroup}>
                <div style={styles.choicesContainer}>
                    {corrals.map((choice, index) => (
                    <div key={index} style={styles.choiceTag}>
                        <span>{choice}</span>
                        <button
                        onClick={() => handleRemoveChoice(index)}
                        style={styles.removeChoiceBtn}
                        >
                            <XMarkIcon style={styles.icon} />
                        </button>
                    </div>
                    ))}
                </div>
                
                <div style={styles.addChoiceContainer}>
                    <input
                    type="text"
                    value={newChoice}
                    onChange={(e) => setNewChoice(e.target.value)}
                    onKeyPress={(e) => e.key === "Enter" && handleAddChoice()}
                    style={styles.choiceInput}
                    placeholder="Ajouter une option..."
                    />
                    <button onClick={handleAddChoice} style={styles.addChoiceBtn}>
                        <PlusIcon style={{...styles.icon}} />
                    </button>
                </div>
                </div>
            </Section>
          </div>
        </div>
    );
}

const styles = {
  step1: {
    backgroundColor: theme.colors.white,
    borderRadius: theme.radius.lg,
    overflow: "hidden",
  },
  mainColumn: {
    padding: `${theme.spacing.massive} ${theme.spacing.lg}`,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.xxl,
    marginLeft: theme.spacing.huge,
    marginRight: theme.spacing.huge,
  },
  description: {
    margin: `0 0 ${theme.spacing.md} 0`,
    fontSize: theme.fonts.size.sm,
    color: theme.colors.textMuted,
    fontStyle: "italic",
  },
  choicesContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing.xs,
    marginBottom: theme.spacing.sm,
    minHeight: "32px",
  },  
  formGroup: {
    marginBottom: theme.spacing.md,
  },
  choiceTag: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.xs,
    backgroundColor: theme.colors.light,
    color: theme.colors.primary,
    padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
    borderRadius: theme.radius.lg,
    fontSize: theme.fonts.size.xs,
  },
  removeChoiceBtn: {
    background: "none",
    border: "none",
    cursor: "pointer",
    color: theme.colors.primary,
    fontSize: theme.fonts.size.sm,
    padding: "0",
  },
  addChoiceContainer: {
    display: "flex",
    gap: theme.spacing.xs,
    alignItems: "center",
  },
  choiceInput: {
    flex: 1,
    padding: `${theme.spacing.sm} ${theme.spacing.md}`,
    border: `1px solid ${theme.colors.border}`,
    borderRadius: theme.radius.lg,
    fontSize: theme.fonts.size.sm,
  },
  addChoiceBtn: {
    padding: `${theme.spacing.sm} ${theme.spacing.md}`,
    backgroundColor: theme.colors.light,
    color: theme.colors.textInverted,
    border: "none",
    borderRadius: theme.radius.lg,
    cursor: "pointer",
    fontWeight: theme.fonts.weight.medium,
    fontSize: theme.fonts.size.base,
  },
  icon  : {
    height : theme.iconSize.sm,
    width : theme.iconSize.sm,
    color : theme.colors.textInverted,
    verticalAlign: "middle",
  },
};
